<template lang="pug">
  .column.middle.center
    in-progress(:description='$t("krea.inRevision.inRevisionDescription")')
    router-link.primary-button.m-top-4(:to='{name: routes.kreaCreateEducationalContent}')
      | {{ $t("krea.contentList.createContent") }}
</template>

<script>
import InProgress from '@/components/InProgress'
import { routes } from '../router'

export default {
  components: { InProgress },
  data() {
    return {
      routes
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
